import React, { useState, useEffect } from "react";
// Chakra imports
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Icon,
  Link,
  Switch,
  Text,
  useColorModeValue,
  InputGroup,
} from "@chakra-ui/react";
// Assets
import signInImage from "assets/img/signInImage.png";
import { FaApple, FaFacebook, FaGoogle, FaWindows } from "react-icons/fa";
import { useAuth } from "../../components/UseContext/authContext";

import toast, { Toaster } from "react-hot-toast";

import { message } from "antd";

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");
  const bgForm = useColorModeValue("white", "navy.800");
  const titleColor = useColorModeValue("gray.700", "blue.500");
  const colorIcons = useColorModeValue("gray.700", "white");
  const bgIcons = useColorModeValue("trasnparent", "navy.700");
  const bgIconsHover = useColorModeValue("gray.50", "whiteAlpha.100");

  const [statusboton, setStatusboton] = useState(true);

  const [messageApi, contextHolder] = message.useMessage();

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Login successful.",
    });
  };

  const error_email = () => {
    messageApi.open({
      type: "error",
      content: "Login failed. Verify your email and password.",
    });
  };

  const error_empty = () => {
    messageApi.open({
      type: "error",
      content: "Complete the form",
    });
  };

  const error_email_invalid = () => {
    messageApi.open({
      type: "error",
      content: "Enter a valid Email",
    });
  };

  const [pass, setPass] = useState("");
  const [email, setEmail] = useState("");

  const [errorpass, setErrorpass] = useState("skyblue");
  const [erroremail, setErroremail] = useState("skyblue");

  const notify_error = () => toast.error("Complete the form");
  const notify_sucess = () => toast.success("Login successful.");

  const notify_error2 = () =>
    toast.error("Login failed. Verify your email and password.");

  const notify_error_email = () => toast.error("Enter a valid Email");

  const registrando = (
    <>
      <span className="loader"></span> &nbsp;&nbsp;&nbsp; Please wait...
    </>
  );

  const signup = <>LOGIN</>;

  const handleregister = () => {
    alert(document.getElementById("name-royal").value);

    const switchElement = document.getElementById("remember-login");
    const isChecked = switchElement.checked;
    alert(isChecked);
  };

  const register = () => {
    window.location.href = "/#/auth/signup";
    window.location.reload();
  };

  const logeo = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    let type_error = "";

    let passt = document.getElementById("password-royal").value;
    let emailt = document.getElementById("email-royal").value;

    if (passt == "") {
      setErrorpass("red");
      type_error = "vacio";
    }
    if (emailt == "") {
      setErroremail("red");
      type_error = "vacio";
    } else if (!emailRegex.test(emailt)) {
      // Email no es válido según el patrón
      setErroremail("red");
      type_error = "email";
    }

    if (type_error === "vacio") {
      error_empty();
      setStatusboton(true);
      return;
    }

    if (type_error === "email") {
      error_email_invalid();
      setStatusboton(true);
      return;
    }

    const data = {
      username: emailt,
      password: passt,
    };
    fetch(`${process.env.REACT_APP_API}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.token) {
            localStorage.setItem("token_royal", result.token);
            success();
            setTimeout(() => {
              window.location.href = "/#/admin/dashboard";
              window.location.reload();
            }, 2000);
          } else {
            if (result.message) {
              if (result.message == "Usuario o Password Incorrectos") {
                error_email();
                setStatusboton(true);
              }
            }
            console.log(result.message);
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (!statusboton) {
      logeo();
    }
    console.log(statusboton);
  }, [statusboton]);

  return (
    <>
      {contextHolder}
      <Flex position="relative" mb="40px">
        <Flex
          minH={{ md: "1000px" }}
          h={{ sm: "initial", md: "75vh", lg: "85vh" }}
          w="100%"
          maxW="1044px"
          mx="auto"
          justifyContent="space-between"
          mb="20px"
          pt={{ md: "0px" }}
        >
          <Flex
            w="100%"
            h="100%"
            alignItems="center"
            justifyContent="center"
            mb="60px"
            mt={{ base: "50px", md: "20px" }}
          >
            <Flex
              zIndex="2"
              direction="column"
              w="445px"
              background="transparent"
              borderRadius="15px"
              p="40px"
              mx={{ base: "100px" }}
              mt={{ base: "20px", md: "auto", sm: "40px" }}
              ml={{ base: "20px", md: "auto", sm: "30px" }}
              mr={{ base: "20px", md: "auto", sm: "30px" }}
              mb={{ base: "20px", md: "auto", sm: "30px" }}
              bg={bgForm}
              boxShadow={useColorModeValue(
                "0px 5px 14px rgba(0, 0, 0, 0.05)",
                "unset"
              )}
            >
              <Text
                fontSize="xl"
                color={textColor}
                fontWeight="bold"
                textAlign="center"
                mb="22px"
              >
                Login
              </Text>
              {/* <HStack spacing="15px" justify="center" mb="22px">
              <Flex
                justify="center"
                align="center"
                w="75px"
                h="75px"
                borderRadius="8px"
                border={useColorModeValue("1px solid", "0px")}
                borderColor="gray.200"
                cursor="pointer"
                transition="all .25s ease"
                bg={bgIcons}
                _hover={{ bg: bgIconsHover }}
              >
                <Link href="#">
                  <Icon as={FaFacebook} color={colorIcons} w="30px" h="30px" />
                </Link>
              </Flex>
              <Flex
                justify="center"
                align="center"
                w="75px"
                h="75px"
                borderRadius="8px"
                border={useColorModeValue("1px solid", "0px")}
                borderColor="gray.200"
                cursor="pointer"
                transition="all .25s ease"
                bg={bgIcons}
                _hover={{ bg: bgIconsHover }}
              >
                <Link href="#">
                  <Icon
                    as={FaApple}
                    color={colorIcons}
                    w="30px"
                    h="30px"
                    _hover={{ filter: "brightness(120%)" }}
                  />
                </Link>
              </Flex>
              <Flex
                justify="center"
                align="center"
                w="75px"
                h="75px"
                borderRadius="8px"
                border={useColorModeValue("1px solid", "0px")}
                borderColor="gray.200"
                cursor="pointer"
                transition="all .25s ease"
                bg={bgIcons}
                _hover={{ bg: bgIconsHover }}
              >
                <Link href="#">
                  <Icon
                    as={FaGoogle}
                    color={colorIcons}
                    w="30px"
                    h="30px"
                    _hover={{ filter: "brightness(120%)" }}
                  />
                </Link>
              </Flex>
            </HStack> */}

              <FormControl>
                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                  Email
                </FormLabel>
                <Input
                  variant="auth"
                  fontSize="sm"
                  ms="4px"
                  type="text"
                  placeholder="jhon@example.com"
                  mb="24px"
                  size="lg"
                  id="email-royal"
                  borderColor={erroremail}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                  Password
                </FormLabel>
                <Input
                  variant="auth"
                  fontSize="sm"
                  ms="4px"
                  type="password"
                  placeholder="Your password"
                  mb="24px"
                  size="lg"
                  id="password-royal"
                  borderColor={errorpass}
                  onChange={(e) => setPass(e.target.value)}
                />
                {/* <FormControl display="flex" alignItems="center" mb="24px">
                <Switch id="remember-login" colorScheme="yellow" me="10px" />
                <FormLabel htmlFor="remember-login" mb="0" fontWeight="normal">
                  Remember me
                </FormLabel>
              </FormControl> */}
                <Button
                  fontSize="16px"
                  variant="dark"
                  fontWeight="bold"
                  w="100%"
                  h="45"
                  mb="24px"
                  onClick={() => {
                    setStatusboton(false);
                  }}
                >
                  {statusboton ? signup : registrando}
                </Button>
              </FormControl>
              <Flex
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                maxW="100%"
                mt="0px"
              >
                <Text color={textColor} fontWeight="medium">
                  Already have an account?
                  <Link
                    href="https://app.royalinsurancellc.com/#/f/1"
                    color={titleColor}
                    fontWeight="bold"
                  >
                    Sign In
                  </Link>
                </Text>
              </Flex>
            </Flex>
          </Flex>
          <Box
            overflowX="hidden"
            h="100%"
            w="100%"
            left="0px"
            position="absolute"
            bgImage={signInImage}
          >
            <Box
              w="100%"
              h="100%"
              bgSize="cover"
              bg="#003366"
              opacity="0.6"
            ></Box>
          </Box>
        </Flex>
      </Flex>
    </>
  );
}

export default SignIn;
